<template>
  <Alert v-if="success" status="success">
    Password Cambiata con successo
  </Alert>
  <FormContainer v-else @submitForm="changePassword">
    <FormErrors v-if="error">
      <Alert status="danger" class="m-0">
        <template v-if="error === 'wrong-password'">
          Password Attuale non correntta, si prega di riprovare.
        </template>
        <template v-else>
          Errore di sistema, riprovare più tardi.
        </template>
      </Alert>
    </FormErrors>

    <div class="container-fluid">
      <div class="row">
        <FormInputTextWidget
          class="col-12"
          label="Inserisci Password Corrente"
          v-model="data.oldPassword"
          :errorMsg="errorHash.oldPassword"
          type="password"
          @input="removeError('oldPassword')"
        />

        <FormInputTextWidget
          class="col-12 col-md-6"
          label="Nuova Password"
          v-model="data.newPassword"
          :errorMsg="errorHash.newPassword"
          type="password"
          @input="removeError('newPassword')"
        />
        <FormInputTextWidget
          class="col-12 col-md-6"
          label="Conferma Password"
          v-model="confirmPassword"
          :errorMsg="errorHash.confirmPassword"
          type="password"
          @input="removeError('confirmPassword')"
        />
      </div>
      <div class="pt-5 text-right">
        <button class="btn btn-primary" @click.prevent="changePassword">
          Aggiorna
        </button>
      </div>
    </div>

  </FormContainer>
</template>

<script>

import validateMixin from '../../../libs/Form/mixins/validate';

export default {
  name: 'profile-password-change',
  mixins: [validateMixin],
  components: {
    FormInputTextWidget: () => import('../../../libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormContainer: () => import('../../../libs/Form/components/FormContainer'),
    FormErrors: () => import('../../../libs/Form/components/FormErrors'),
    Alert: () => import('../../../libs/Feedback/components/Alert'),
  },
  data () {
    return {
      data: {
        oldPassword: '',
        newPassword: '',
      },
      confirmPassword: '',
      error: false,
      success: null,
    };
  },
  methods: {
    changePassword () {
      if (!this.isValid()) {
        return;
      }

      this.$api.changeMyPassword(this.data.oldPassword, this.data.newPassword).then(res => {
        // this.$router.push({ name: 'logout' });
        this.success = true;
      }).catch(error => {
        if (error.response.status === 401) {
          this.error = 'wrong-password';

          return;
        }

        this.error = 'service';
      });
    },
    isValid () {
      if (!this.data.oldPassword) {
        this.addError('Inserisci la password attuale', 'oldPassword');
      }
      if (!this.data.newPassword) {
        this.addError('Inserisci la nuova password', 'newPassword');
      }
      if (!this.confirmPassword) {
        this.addError('Inserisci la password di conferma', 'confirmPassword');
      }

      if (this.data.newPassword.length < 8 || !this.data.newPassword.match(/\d|[^\w\s]/)) {
        this.addError('La password deve avere almeno 8 caratteri, compreso un numero o un simbolo.', 'newPassword');
      } else if (this.data.newPassword !== this.confirmPassword) {
        this.addError('La password e la password di conferma devono essere uguali', 'confirmPassword');
      }

      return !this.hasErrors;
    },
  },
};

</script>
